import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk, AppDispatch } from 'app/store'
import { House } from 'features/houseInfo/types';

const initialState : House = {houseName: "", roomAmount: 0, floorAmount: 0, el_install: false, rooms: [], currentRoom: 0,};


const houseSlice = createSlice({
    name: "house",
    initialState,
    reducers: {
        addHouse(state, action: PayloadAction<House>){
            // console.log(state)
            // console.log(action)
            // state = action.payload
            state.houseName = action.payload.houseName
            state.roomAmount = action.payload.roomAmount
            state.floorAmount = action.payload.floorAmount
            state.el_install = action.payload.el_install
        },
        addRooms(state, action: PayloadAction<object[]>){
            state.rooms = action.payload
        },
        changeCurrentRoom(state, action: PayloadAction<number>){
            state.currentRoom = action.payload
        }
    }
})

export const addHouse = (
    name: string,
    r_amount: number,
    f_amount: number,
    el_install: boolean,
) : AppThunk => async(dispatch: AppDispatch) => {
    const newHouse : House = {
        houseName: name,
        roomAmount: r_amount,
        floorAmount: f_amount,
        el_install: el_install,
        rooms: [],
        currentRoom: 0,
    }
    dispatch(houseSlice.actions.addHouse(newHouse))
}

export const addRooms = (
    roomArr: object[],
) : AppThunk => async(dispatch: AppDispatch) => {
    dispatch(houseSlice.actions.addRooms(roomArr))
}

export const changeCurrentRoom = (
    roomNumber: number
) : AppThunk => async(dispatch: AppDispatch) => {
    dispatch(houseSlice.actions.changeCurrentRoom(roomNumber))
}

export default houseSlice.reducer;